module.exports = __webpack_public_path__ + "static/media/photo112.587136d8.jpg";